export default "__VITE_ASSET__BzlnRrP$__"